export {
  default as grill,
  ReactComponent as Grill,
} from '@assets/icons/features-and-amenities/grill.svg'    
